var dragParams={}; 

/*
window.addEventListener("dx_init", function(){      
    dx_sliders_init();
});
*/
var win = window;
if(window.parent==window){
   
    window.addEventListener("load", function(){
       dx_sliders_init();
    });    
} 


window.addEventListener("dx_slider_init", function(event){ 
    win = window.frames[0]; // is editor
    dx_slider_init(event.detail.block);
});

window.addEventListener("dx_slider_setColumns", function(event){ 
    //console.log("set cols")
    dx_slider_setColumns(event.detail.block);
});

window.addEventListener("dx_slider_update", function(event){ 
    console.log("dx_slider_update");
    //dx_slider_onResize(event.detail.block);
    //dx_slider_update(event.detail.block);
});

function dx_sliders_init(){
    var blocks = document.getElementsByClassName("wp-block-dx-slider"); 
    for(var i = 0; i<blocks.length; i++){  
        dx_slider_init(blocks[i]);
    }    
}   


function dx_slider_init(block){    
    if(block.getAttribute("data-init")=="1"){
        return;
    }
    block.setAttribute("data-init", "1");    
  
    block.setAttribute("data-active", 0);   
    const buttonLeft= block.getElementsByClassName("wp-block-dx-slider-button-left")[0];     
    const buttonRight= block.getElementsByClassName("wp-block-dx-slider-button-right")[0];
    var content = block.getElementsByClassName("wp-block-dx-slider-content")[0];   
    block.addEventListener("touchstart", dx_slider_onDragStart, {passive:true});    
    buttonLeft.addEventListener("click", dx_slider_onButtonLeftClick, {passive:true});    
    buttonRight.addEventListener("click", dx_slider_onButtonRightClick, {passive:true});    
    dx_slider_setColumns(block);
    dx_slider_checkButtons(block); 

    // resize observer
    new ResizeObserver(()=>{       
        dx_slider_onResize(block);
    }).observe(block);

    // slider change observer
    if(window.editor){
        let callback = (block, mutationList, observer) =>{
            for (const mutation of mutationList) {
                let changed = false;
                if (mutation.type === "childList" && mutation.addedNodes.length>0 && mutation.addedNodes[0].classList.contains("wp-block-dx-box")) changed = true;
                if (mutation.type === "childList" && mutation.removedNodes.length>0 && mutation.removedNodes[0].classList.contains("wp-block-dx-box")) changed = true;
                if (changed) {
                    dx_slider_checkButtons(block);                     
                } 
            }
        }
        const observer = new MutationObserver(callback.bind(null, block));
        observer.observe(content, { childList: true, subtree: false });
    } 
}

function dx_slider_checkButtons(element){
    const content = element.getElementsByClassName("wp-block-dx-slider-content")[0];   
    const buttonLeft= element.getElementsByClassName("wp-block-dx-slider-button-left")[0];     
    const buttonRight= element.getElementsByClassName("wp-block-dx-slider-button-right")[0];
    buttonLeft.style.opacity = parseInt(element.getAttribute("data-active"))===0 ? 0.3 : 1; 
    var maxActive=Math.max(0, dx_slider_getItems(element) - dx_slider_getVisibleItems(element));
    buttonRight.style.opacity = parseInt(element.getAttribute("data-active"))===maxActive ? 0.3 : 1;         
}

function dx_slider_getVisibleItems(element){   
    const boxes=element.getElementsByClassName("wp-block-dx-box");  
    const spacing = parseInt(getComputedStyle(element.getElementsByClassName("wp-block-dx-slider-content")[0]).gap);
    const columns = Math.round((element.offsetWidth + spacing) / (boxes[0].offsetWidth + spacing));
    return columns;
}
function dx_slider_getItems(element){        
    const boxes = element.querySelectorAll('.wp-block-dx-slider-content > .wp-block-dx-box');
    return (window.editor) ? boxes.length + 1 : boxes.length;
}

function dx_slider_update(element, transition=true){ 
    var content = element.getElementsByClassName("wp-block-dx-slider-content")[0];      
    var active = parseInt(element.getAttribute("data-active"));    
    var maxActive = Math.max(0, dx_slider_getItems(element) - dx_slider_getVisibleItems(element));    
    if(active > maxActive){
        active = maxActive;
        element.setAttribute("data-active", active);
    }  
   let activeElement = element.querySelectorAll('.wp-block-dx-slider-content:first-child > .wp-block-dx-box')[active]; 
    if(activeElement == undefined){
        activeElement = element.querySelectorAll('.wp-block-dx-slider-content:first-child > .block-list-appender')[0];
    } 
    if(activeElement == undefined){
        activeElement = {offsetLeft: 0}; //for preview
    }
    if(!transition){
        content.style.transition="left 0s";
    } 
    //console.log(activeElement.offsetLeft);
    content.style.left=-activeElement.offsetLeft +"px";   
    setTimeout(()=>{
        content.style.transition="left 0.3s";
    }, 1);     
    dx_slider_checkPageBg(element, activeElement);
    dx_slider_checkButtons(element);
}

function dx_slider_checkPageBg(element, activeElement){    
    const bgUrl = activeElement.getAttribute("data-bg-url");
    if(bgUrl && bgUrl!=""){
        dx_setBackgroundImage(activeElement.getAttribute("data-bg-url"), activeElement.getAttribute("data-bg-x"), activeElement.getAttribute("data-bg-y")); 
    } 
}

function dx_slider_onButtonLeftClick(event){  
    var element = event.currentTarget.parentNode; 
    var content = element.getElementsByClassName("wp-block-dx-slider-content")[0];   
    
    content.style.transition="left 0.3s";
    var oldActive = parseInt(element.getAttribute("data-active")); 
    var active = oldActive>0 ? oldActive-1 : oldActive;
    element.setAttribute("data-active", active);
    dx_slider_update(element);   
}    
function dx_slider_onButtonRightClick(event){  
    var element = event.currentTarget.parentNode; 
    var content = element.getElementsByClassName("wp-block-dx-slider-content")[0];  

    content.style.transition="left 0.3s";
    var oldActive = parseInt(element.getAttribute("data-active")); 
    var active = oldActive<dx_slider_getItems(element) - dx_slider_getVisibleItems(element) ? oldActive+1 : oldActive;
    element.setAttribute("data-active", active);
   
    dx_slider_update(element);  

} 
function dx_slider_getDragCoordinates(event) {
    if(event.touches!==undefined){
        return {x:event.touches[0].pageX, y:event.touches[0].pageY}
    }
    return {x:event.pageX, y:event.pageY};
}
function dx_slider_onDragStart(event){
    var content = event.currentTarget.getElementsByClassName("wp-block-dx-slider-content")[0];
    content.style.transition="none";
    var dragCoordinates = dx_slider_getDragCoordinates(event);
    dragParams.oldX=0;
    dragParams.currentX=0;
    dragParams.slider=event.currentTarget;
    dragParams.content=content;
    dragParams.contentX=content.offsetLeft; 
    dragParams.startX=dragCoordinates.x;
    dragParams.startY=dragCoordinates.y;
    window.document.addEventListener("touchmove", dx_slider_onDragMove, {passive: false});
    window.document.addEventListener("touchend", dx_slider_onDragEnd, {passive:true});
} 
function dx_slider_onDragMove(event){
    var dragCoordinates = dx_slider_getDragCoordinates(event);
    dragParams.oldX=dragParams.currentX;
    dragParams.currentX=dragCoordinates.x;
    if(dragParams.direction===undefined){
        if(Math.abs(dragParams.startX - dragCoordinates.x) > 5){
            dragParams.direction = "h";
        } else if(Math.abs(dragParams.startY - dragCoordinates.y) > 5){
            dragParams.direction = "v";
        }
    }
    
    if(dragParams.direction === "h"){
        dragParams.content.style.left = (dragParams.contentX+(dragParams.currentX-dragParams.startX))+"px"; 
        if (event.cancelable) {
            event.preventDefault();
        } 
    }
    if(dragParams.direction === "v"){ 
        dragParams.content.style.transition="left 0.3s";
    }
}
function dx_slider_onDragEnd(){
    window.document.removeEventListener("touchmove", dx_slider_onDragMove);
    window.document.removeEventListener("touchend", dx_slider_onDragEnd);
    if(dragParams.direction === "h"){
        //var box=checkAdminBox(dragParams.slider.getElementsByClassName("wp-block-digitalex-box")[0]);
        //var boxWidth=getElementWidth(box);
        //var maxActive=dragParams.content.childElementCount - dx_slider_getVisibleItems(dragParams.slider);
        var pos;
        var boxes = dragParams.slider.getElementsByClassName("wp-block-dx-box");
       
        var maxActive= dx_slider_getItems(dragParams.slider) - dx_slider_getVisibleItems(dragParams.slider);
        
        if(boxes.length>1){
            var boxWidth = boxes[1].offsetLeft;           
            var impulse=dragParams.currentX-dragParams.oldX;
            if(impulse > 5){
                pos = Math.floor(( -dragParams.content.offsetLeft) / boxWidth);
            } else if(impulse < -5){
                pos = Math.floor((boxWidth - dragParams.content.offsetLeft) / boxWidth);
            } else {
                pos = Math.floor((boxWidth / 2 - dragParams.content.offsetLeft) / boxWidth);
            }
        } else {
            pos=0;
        }
        var active = Math.max(0, Math.min(maxActive, pos));
        dragParams.slider.setAttribute("data-active", active);
        dragParams.content.style.transition="left 0.3s";
        dx_slider_update(dragParams.slider); 
    }
    dragParams={}; 
} 

function dx_slider_onResize(element){
    var content = element.getElementsByClassName("wp-block-dx-slider-content")[0];
    content.style.transition="left 0s";   
    dx_slider_setColumns(element);
    dx_slider_update(element);
    
    setTimeout(()=>{
        content.style.transition="left 0.3s";
    }, 1)
} 
function dx_slider_setColumns(element){  
    element.classList.remove("dx-slider-cols1");
    element.classList.remove("dx-slider-cols2");
    element.classList.remove("dx-slider-cols3");
    for(let i = 1; i <= 20; i++){
        element.classList.remove("dx-slider-thumbs"+i);
    }
   

    var frame = element.getElementsByClassName("wp-block-dx-slider-frame")[0];
    if(frame.classList.contains("dx-slider-full")){
        return;
    }   
    
    let usedColumns = dx_slider_getUsedColumns(element);   
    
    if(!Number.isInteger(usedColumns)){       
        usedColumns = 1; // not fitting into columns       
    }    
    element.classList.add("dx-slider-cols"+usedColumns);   

    let fittingThumbs = dx_getFittingThumbs(element);   
    if(!Number.isInteger(fittingThumbs)){       
        fittingThumbs = 1; // not fitting into columns       
    }    
    element.classList.add("dx-slider-thumbs"+fittingThumbs);  
    
    //console.log(element.classList)

}



function dx_slider_getUsedColumns(element){
    
   
    //var win = window;   
    //win = window.frames[0];
   
    
    const spacing = dx_slider_getCSSColSpacing();
    const columns = dx_slider_getCSSCols();
    
    const container = win.document.getElementsByClassName("dx-content")[0] || win.document.getElementsByClassName("is-root-container")[0];
    const containerWidth = container.getBoundingClientRect().width - spacing;
    const elementWidth = element.getBoundingClientRect().width + spacing;
    const columnWidth = containerWidth / columns;
    const usedColumns = Math.round(elementWidth / columnWidth *10)/10;

    console.log(columns);
    return usedColumns;
   
}

function dx_slider_getCSSColSpacing(){

    //var win = window;
    //win = window.frames[0];
    
    const content = win.document.body.getElementsByClassName("dx-content")[0] || win.document.body.getElementsByClassName("is-root-container")[0];
    return parseInt(getComputedStyle(content).paddingLeft);
}

function dx_slider_getCSSCols(){   
    //var win = window;
    //win = window.frames[0];
    
    let cols = 1;
    const documentWidth = win.document.body.offsetWidth;
    const breakpoints = win.getComputedStyle(win.document.querySelector('html'), ':before').content.split('"').join('').split(",");
    
    while(documentWidth >= breakpoints[cols] && cols <= breakpoints.length){
        cols++;        
    }   
    return cols;
    
}

function dx_getFittingThumbs(element){
    //return 5;
    
    const thumbSize = 80;
    
    const elementWidth = element.getBoundingClientRect().width;
    const fittingThumbs = Math.floor(elementWidth / thumbSize);
    

    return fittingThumbs;
    
}
 

